module.exports = __webpack_public_path__ + "img/sessionOneBg.fbb8eb4e.png";